import { ref } from 'vue'

/** 列表页可折叠筛选区：点工具栏「查询」展开，面板内点查询才生效 */
export function useListFilterPanel(syncDraftFilters) {
  const filterVisible = ref(false)

  const toggleFilter = () => {
    if (!filterVisible.value) {
      syncDraftFilters?.()
    }
    filterVisible.value = !filterVisible.value
  }

  return {
    filterVisible,
    toggleFilter,
  }
}
